import React from "react";
import PropTypes from "prop-types";
import {Grid} from "@mui/material";
import {StyledSkeleton} from "../skeletons/StyledSkeleton";
import {map} from "underscore";

export const SkeletonDialog = ({numberOfItems = 1}) => (
  <Grid id="skeleton-dialog" data-testid="skeleton-dialog">
    <StyledSkeleton
      sx={{height: 40, width: "100%", marginTop: 1, marginBottom: 3}}
    />
    {map(Array(numberOfItems), (each, index) => (
      <StyledSkeleton
        sx={{
          height: 40,
          width: "100%",
          marginBottom: numberOfItems > 1 ? 1 : undefined,
        }}
        key={index}
      />
    ))}
  </Grid>
);

SkeletonDialog.propTypes = {
  numberOfItems: PropTypes.number,
};
